import { SelectOption } from '../components/Select';

const useOptions = <T>(
  data: Array<T> = [],
  mapper: (listItem: T) => SelectOption,
  currentValue?: T,
) => {
  const currentOption = currentValue != null ? mapper(currentValue) : null;

  const options: SelectOption[] =
    data
      .map(mapper)
      .filter((option) => option.value !== currentOption?.value) ?? [];

  if (currentOption) {
    options.unshift(currentOption);
  }

  return options;
};

export default useOptions;
